// Opens the newsletter popup (snippets/newsletter-popup.liquid) on the 2nd page view of the
// session or after 20 s on the page, whichever comes first. Closing snoozes it for 30 days;
// a successful signup (?customer_posted=true) shows the code and silences it for good.
const SNOOZE_KEY = 'gb-newsletter-snooze';
const VIEWS_KEY = 'gb-newsletter-views';
const SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;
const DELAY_MS = 20000;
const SECOND_VIEW_DELAY_MS = 2500;

const component = document.querySelector('dialog-component.newsletter-popup');

function read(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function write(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {}
}

function isBlocked() {
  // Never stack on another open dialog (cart drawer, search, …) or on the cookie banner.
  if (document.querySelector('dialog[open]')) return true;
  const banner = document.getElementById('shopify-pc__banner');
  return Boolean(banner && banner.offsetParent !== null);
}

async function open(force = false) {
  await customElements.whenDefined('dialog-component');
  if (!force && isBlocked()) {
    setTimeout(() => open(), 3000);
    return;
  }
  if (!force && isSnoozed()) return;
  component.showDialog();
}

function isSnoozed() {
  const snooze = read(localStorage, SNOOZE_KEY);
  return snooze === 'done' || (snooze !== null && Date.now() < Number(snooze));
}

if (component) {
  if (component.querySelector('[data-nl-success]')) {
    write(localStorage, SNOOZE_KEY, 'done');
    open(true);
  } else if (component.querySelector('[data-nl-error]')) {
    open(true);
  } else if (!isSnoozed()) {
    const views = Number(read(sessionStorage, VIEWS_KEY) || 0) + 1;
    write(sessionStorage, VIEWS_KEY, String(views));
    setTimeout(open, views >= 2 ? SECOND_VIEW_DELAY_MS : DELAY_MS);
  }

  component.addEventListener('dialog:close', () => {
    if (read(localStorage, SNOOZE_KEY) !== 'done') write(localStorage, SNOOZE_KEY, String(Date.now() + SNOOZE_MS));
  });
}
